






















































































import OfficePicker from "@/components/pickers/office-selector.vue";
import { presenceService } from "@/services/presence";
import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import UserSelector from "@/components/pickers/user-selector.vue";
import { Watch } from "vue-property-decorator";
import DateRangePicker from "@/components/pickers/date-range-picker.vue";
import { DateTime } from "luxon";
import DataTable from "@/components/data/data-table.vue";
import { DataTableField } from "@/components/data/data-table";
import { unparse } from "papaparse";
import { ContactTraceResult, PresenceResult } from "@/swagger/models";

@Component({
    name: "report-contact-trace",
    components: { OfficePicker, DataTable, DateRangePicker, UserSelector, Page },
})
export default class ReportContactTrace extends Vue {
    userId: number | null = null;
    officeId: number | null = null;

    resultsPerPage: number = 50;
    page: number = 1;
    get pages() {
        return Math.ceil(this.results.length / this.resultsPerPage);
    }

    // Default: last month
    range: DateTime[] = [
        DateTime.local().minus({ months: 1 }).startOf("month"),
        DateTime.local().minus({ months: 1 }).endOf("month"),
    ];
    loading: boolean = false;

    results: PresenceResult[] = [];
    fields: DataTableField<ContactTraceResult>[] = [
        {
            label: "ID",
            field: "userId",
        },
        {
            label: "User",
            field: "firstName",
            format: (v, line: PresenceResult) => `${line.firstName} ${line.lastName}`,
        },
        {
            label: "Office",
            field: "officeName",
        },
        {
            label: "Days present",
            field: "daysPresent",
        },
        {
            label: "Teams",
            field: "teams",
            format: (teams: string[]) => teams.join(", "),
        },
    ];

    @Watch("userId")
    @Watch("officeId")
    @Watch("range")
    async updateResults() {
        try {
            this.loading = true;
            this.results = await presenceService.getReport({
                startDate: this.range[0].toISODate(),
                endDate: this.range[1].toISODate(),
                customerId: this.$context.customer.id,
                userId: this.userId || undefined,
                officeId: this.officeId || undefined,
            });
            this.page = 1;
        } catch (e) {
            console.warn(e);
        } finally {
            this.loading = false;
        }
    }

    get pagedResults() {
        return this.results.slice((this.page - 1) * this.resultsPerPage, this.page * this.resultsPerPage);
    }

    async exportToCSV() {
        const csv = unparse(
            this.results.map((line: PresenceResult) => {
                // Change the keys to be more human readable
                return {
                    "User ID": line.userId,
                    Name: `${line.firstName} ${line.lastName}`,
                    Office: line.officeName,
                    "Days present": line.daysPresent,
                    "Team(s)": line.teams.join(", "),
                };
            }),
            {},
        );

        // Yay javascript
        const element = document.createElement("a");
        element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(csv));
        element.setAttribute(
            "download",
            `presence-report-${this.range[0].toLocaleString(DateTime.DATE_SHORT)}-${this.range[1].toLocaleString(
                DateTime.DATE_SHORT,
            )}.csv`,
        );
        element.style.display = "none";
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
    }
}
